import { Logo } from './LogoComponent';
import { Page } from './PageComponent';
export { Logo, Page };
